export default "__VITE_ASSET__BAUznRVN__"